import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private headernav$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    true
  );

  constructor() { }

  getHeaderObservable(): Observable<boolean> {
    return this.headernav$.asObservable();
  }

  toggleHeader(): void {
    this.headernav$.next(!this.headernav$.value);
  }
}
